import React from "react";
import clsx from "clsx";

import SurfaceRowContent from "./SurfaceRowContent";
import { IRowData } from "../helper";
import useStyles from "../styles";

interface IProps {
  data: IRowData;
}

const TableRow = (props: IProps) => {
  const { backgroundClassName, surfaces, totalCount } = props.data;
  const classes = useStyles();

  const renderSurfaces = () => {
    return surfaces.map((surface, index) => (
      <SurfaceRowContent
        key={index}
        surfaceData={surface}
        additionalClassName={backgroundClassName}
      />
    ));
  };

  return (
    <>
      <div className={clsx(classes.cell, backgroundClassName)}>
        {totalCount}
      </div>

      {renderSurfaces()}
    </>
  );
};

export default TableRow;
